import { RouteRecordRaw } from "vue-router";

export const parcelTypeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/parcel-types/:id/edit",
    name: "ParcelTypeEdit",
    component: () => import("../views/ParcelTypeEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "parcelType",
      requiredRight: "viewUI",
    },
  },
];
